document.addEventListener('alpine:init', () => {
  Alpine.store('cart_count', {
    count: (window.theme && window.theme.cartItemCount) || 0,
    _refreshInFlight: null,
    _lastRefreshAt: 0,
    _refreshMinIntervalMs: 1500,
    init() {
      window.addEventListener('cascade:modalcart:afteradditem', (e) => {
        this._setFromFetchedSection(e.detail.response);
      });

      window.addEventListener('cascade:modalcart:cartqtychange', (e) => {
        this._setFromFetchedSection(e.detail.response);
      });

      // Browsers can restore a cached page snapshot on back/forward navigation.
      // Refresh cart count from Shopify to avoid showing stale badge values.
      window.addEventListener('pageshow', (event) => {
        const nav = performance.getEntriesByType('navigation')[0];
        const isBackForward =
          event.persisted || (nav && nav.type === 'back_forward');

        if (isBackForward) {
          this.refreshFromServer({ force: true });
        }
      });

      // On tab return/focus, revalidate badge count in case cart changed elsewhere.
      document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'visible') {
          this.refreshFromServer();
        }
      });

      window.addEventListener('focus', () => {
        this.refreshFromServer();
      });

      // If user regains connectivity, refresh stale badge count.
      window.addEventListener('online', () => {
        this.refreshFromServer({ force: true });
      });
    },
    _setFromFetchedSection(data) {
      const countSectionHTML = data.sections['cart-item-count'];

      this.count = parseInt(
        parseDOMFromString(countSectionHTML).firstElementChild.innerText.trim(),
        10
      );
    },
    async refreshFromServer({ force = false } = {}) {
      const now = Date.now();
      if (!force && now - this._lastRefreshAt < this._refreshMinIntervalMs) {
        return;
      }

      if (this._refreshInFlight) {
        return this._refreshInFlight;
      }

      this._lastRefreshAt = now;

      this._refreshInFlight = (async () => {
      try {
        const response = await fetch(`${theme.routes.cart_url}.js`, {
          method: 'GET',
          headers: { Accept: 'application/json' },
        });
        if (!response.ok) return;

        const cart = await response.json();
        this.count = Number(cart.item_count) || 0;
      } catch (_error) {
        // Keep existing count if refresh fails.
      } finally {
        this._refreshInFlight = null;
      }
      })();

      return this._refreshInFlight;
    },
    countWithText() {
      let string = theme.strings.itemCountOther;

      if (this.count === 1) {
        string = theme.strings.itemCountOne;
      }

      return string.replace('{{ count }}', this.count);
    },
  });
});
